"use strict";function datepicker$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.datepicker$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.datepicker";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.4.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.4.0"},_a)),exports.datepicker$=datepicker$,exports.default=datepicker$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/datepicker.js
// module id = 1004
// module chunks = 106